import * as I18n from 'circe/I18n';

export const FORM_NAME = 'CREATE_NEW_USER';
export const ROLES = [
  {
    value: 'ACCOUNT_ADMIN',
    label: I18n.str('ACCOUNT_ADMIN', 'Account Admin'),
  },
  {
    value: 'FINANCE_ADMIN',
    label: I18n.str('FINANCE_ADMIN', 'Finance Admin'),
  },
  {
    value: 'FLEET_ADMIN',
    label: I18n.str('FLEET_ADMIN', 'Fleet Admin'),
  },
  {
    value: 'OPERATOR',
    label: I18n.str('OPERATOR', 'Operator'),
  },
  {
    value: 'DISPATCHER',
    label: I18n.str('DISPATCHER', 'Dispatcher'),
  },
  {
    value: 'CASHIER',
    label: I18n.str('CASHIER', 'Cashier'),
  },
  {
    value: 'CALL_CENTER_ASSOCIATE',
    label: I18n.str('CALL_CENTER_ASSOCIATE', 'Call Center Associate'),
  },
  {
    value: 'SECURITY_GUARD',
    label: I18n.str('SECURITY_GUARD', 'Security Guard'),
  },
];
export const ROUTES = {
  ROOT: '/users/create/:role?',
};

export const PAGE_NAME = I18n.str('createNewVendor', 'Create New Vendor');
